import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
const { FIREBASE_API } = require('src/config-global');

const firebaseApp = !getApps().length ? initializeApp(FIREBASE_API) : getApp();
export const firebaseAuth = getAuth(firebaseApp);

const useFirebaseApp = () => {
  return { firebaseAuth, firebaseApp };
};

export default useFirebaseApp;